/* sb-dc-eventhumbs.js — make the template grid read evenly. 2026-09-04.

   Every tile is the same 4:3 box, but the artwork inside is not: a 10x3 banner
   fills a third of the tile's height, a square sticker fills all of it, and a
   31.5x80 retractable is a sliver down the middle. Same tile, wildly different
   pictures — which is what "the templates are all different sizes" means when
   you look at the page.

   Rather than crop the designs to force a match (a banner cropped to 4:3 loses
   its own text), the tile is shaped to the artwork. When the visitor is
   filtering by product — the normal way this page is used — everything on
   screen is one shape, so the tiles become that shape and every design fills
   its tile the same way. Mixed views, where no single shape dominates, keep
   the 4:3 default.

   The measurement is on the images actually rendered, not the database: a
   template's file is the truth about its proportions. Only loaded images
   count, and the ratio is re-measured whenever the grid changes, because both
   the filters and lazy loading rewrite what is on screen.

   Diagnostics: window.__dcEvenThumbs. */
(function () {
  'use strict';

  var STYLE_ID = 'sbdt-eventhumbs-css';
  var DEFAULT = 4 / 3;
  var MIN = 0.42, MAX = 3.2;      // a retractable, and a 10x3 banner
  var SPREAD_OK = 1.6;            // beyond this the view is genuinely mixed
  var stats = { measured: 0, ratio: DEFAULT, mixed: true, fixed: '' };
  window.__dcEvenThumbs = stats;

  /* 2026-09-06 — 묶음이 정해진 상품(#sbdt-root[data-box])은 여기서 재지 않는다.
     비율은 sections/sb-dc-templates.liquid 의 RATIO 표가 정하고, 그 파일의
     render() 가 칸을 그리기 «전» 에 --sbdt-a 를 박아 넣는다.

     왜 그리로 옮겼나: 여기서 재려면 그림이 와야 하므로 250ms 늦는다. 그동안
     칸이 기본 4:3 으로 그려졌다가 정해진 비율로 «튀었다» (세로형 182.3px →
     371.8px). 사장님이 «박스가 뚜둑하고 커진다» 하신 것이 이것이다.
     상품만 알면 비율이 바로 나오는 값이라 잴 이유가 없었다.
     표를 두 곳에 두면 어긋나므로 이 파일에 있던 비율표도 그리로 합쳤다.

     묶음 밖 상품(Window Decals, Kiss-Cut Stickers, All products)은 예전 그대로
     아래 measure() 가 화면에 뜬 그림을 재서 정한다. */
  function fixedBox() {
    var root = document.getElementById('sbdt-root');
    return (root && root.dataset.box) || '';
  }

  function css() {
    if (document.getElementById(STYLE_ID)) return;
    var st = document.createElement('style');
    st.id = STYLE_ID;
    /* The padding is the other half of "even": without it a square design
       touches all four edges while a wide one floats in the middle. */

    /* 2026-09-06 (3차) — 사파리에서 그림 위아래가 «잘리던» 문제.
       크롬은 멀쩡했다. 사장님이 사파리 화면에서 잡아 주셨다.

       칸(.sbdt-thumb)의 높이는 aspect-ratio 로 정해진다 — 숫자로 적어 둔 height
       가 없다. 그런데 그림에는 max-height 가 «퍼센트» 로 걸려 있었다(100%).
         크롬  : aspect-ratio 로 나온 높이를 «정해진 높이» 로 보고 100% 를 계산
                 → 그림을 칸에 맞춰 줄인다
         사파리: «높이가 안 정해졌다» 고 보고 max-height 를 없는 것으로 처리
                 → 그림이 제 원래 높이로 커지고 칸의 overflow:hidden 이 잘라 낸다
       가로(max-width)는 폭이 확실히 정해져 있어 두 브라우저 다 잘 됐다.

       ⚠ 왜 «이제» 티가 났나: 예전에는 이 파일이 그림을 재서 칸 비율을 그림과
         거의 같게 맞췄으므로 넘칠 것이 없었다. 2026-09-06 부터 칸 비율을
         상품별로 «고정»(가로 1.70 / 정사각 1.00 / 세로 0.65)하면서, 그보다
         홀쭉한 그림(리트랙터블 원본은 0.41)이 칸보다 세로로 길어졌다.
         크롬은 줄여 넣고, 사파리는 잘랐다.

       고침: 퍼센트 높이를 아예 안 쓴다. 그림을 «절대 위치» 로 띄우면 기준이
       칸의 실제 크기(패딩 박스)가 되어 어느 브라우저에서나 똑같이 계산된다.
       네 방향 0 + margin:auto 는 «가운데 놓기» 의 표준 방법이다.
       12px = 바로 위에서 칸에 주는 안쪽 여백 6px × 양쪽.

       ⚠ 그림 «자체» 크기는 그대로 둔다(width/height auto). 여기서 100% 로
         늘리면 sb-dc-roundthumb.js 가 원형 스티커에 거는 border-radius:50% 가
         그림이 아니라 «칸» 을 동그랗게 만들어 모양이 깨진다.
       되돌리려면 아래 img 규칙을
         max-width:100%;max-height:100%;width:auto;height:auto
       로 되돌린다(사파리 잘림도 같이 돌아온다). */
    st.textContent =
      '#sbdt-root .sbdt-thumb{aspect-ratio:var(--sbdt-a,4/3) !important;' +
      'padding:6px;box-sizing:border-box;background:#fff}' +
      '#sbdt-root .sbdt-thumb img{position:absolute;top:0;right:0;bottom:0;left:0;' +
      'margin:auto;width:auto;height:auto;' +
      'max-width:calc(100% - 12px);max-height:calc(100% - 12px)}';
    document.head.appendChild(st);
  }

  function measure() {
    var box = fixedBox();
    if (box) {
      /* 섹션이 이미 넣어 둔 값을 «읽기만» 한다. 여기서 다시 쓰면 두 곳이 같은
         자리를 놓고 다투게 되고, 값이 어긋나면 또 튄다. */
      var r0 = document.getElementById('sbdt-root');
      var v = r0 ? parseFloat(getComputedStyle(r0).getPropertyValue('--sbdt-a')) : 0;
      stats.ratio = v || DEFAULT; stats.mixed = false; stats.fixed = box;
      return;
    }
    stats.fixed = '';

    var imgs = document.querySelectorAll('#sbdt-root .sbdt-thumb img');
    var a = [];
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].naturalWidth && imgs[i].naturalHeight) {
        a.push(imgs[i].naturalWidth / imgs[i].naturalHeight);
      }
    }
    if (a.length < 3) return;
    a.sort(function (x, y) { return x - y; });
    var lo = a[Math.floor(a.length * 0.1)], hi = a[Math.floor(a.length * 0.9)];
    var med = a[Math.floor(a.length / 2)];
    var mixed = (hi / lo) > SPREAD_OK;
    var ratio = mixed ? DEFAULT : Math.max(MIN, Math.min(MAX, med));

    stats.measured = a.length; stats.ratio = ratio; stats.mixed = mixed;
    var root = document.getElementById('sbdt-root');
    if (root) root.style.setProperty('--sbdt-a', ratio.toFixed(3));
  }

  function start() {
    var root = document.getElementById('sbdt-root');
    if (!root) return;
    css();
    measure();
    var pending = null;
    function later() { clearTimeout(pending); pending = setTimeout(measure, 250); }
    if (window.MutationObserver) {
      new MutationObserver(later).observe(root, { childList: true, subtree: true });
    }
    /* Lazy images finish loading without touching the DOM, so poll as well. */
    var t = setInterval(measure, 700);
    window.addEventListener('resize', later);
    window.addEventListener('pagehide', function () { clearInterval(t); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
